import { env } from "app/lib/env_client";
import { PlacemarkIcon } from "app/components/elements";

type SigninFormProps = {
  onSuccess?: () => void;
};

export const SigninForm = (props: SigninFormProps) => {
  const googleLoginUrl = (() => {
    const params = new URLSearchParams({
      client_id: env.NEXT_PUBLIC_GOOGLE_CLIENT_ID!,
      redirect_uri: `${env.NEXT_PUBLIC_DOMAIN}api/auth/callback/google`,
      response_type: 'code',
      scope: 'email profile',
    });
    return `https://accounts.google.com/o/oauth2/v2/auth?${params}`;
  })();

  return (
    <div className="px-8 py-4 rounded-lg bg-white">
      <a
        href={googleLoginUrl}
        className="inline-flex items-center justify-center gap-x-2 w-[300px] py-4 border border-gray-200 rounded-lg text-base font-medium text-gray-900 text-center hover:bg-gray-50"
      >
        <PlacemarkIcon className="w-6 h-6 text-purple-500" />
        Sign in with Google
      </a>
    </div>
  );
};

export default SigninForm;
